import Vue from 'vue';
import App from './App.vue';
import router from './router';
import http from '@/http';
import 'lib-flexible/flexible';
import Router from 'vue-router';
import ElementUI from 'element-ui';
import FastClick from 'fastclick';
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/element-var.css';

Vue.use(vueSwiper)
Vue.use(ElementUI);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.$bus = new Vue();
FastClick.attach(document.body);
new Vue({
    render: h => h(App),
    router
}).$mount('#app')